import React from 'react';

/** Construction & tools (from user asset; fill uses currentColor for sidebar theming). */
const SidebarContractorsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path d="M362.4,431.8c-16,44.3-49,75.4-95.5,79.8h-21.8c-46.9-4.5-80.1-36.1-95.5-80,6.9-3.5,9.4-9.5,8.6-17.2,56.7,47.6,138.8,47.7,195.6,0-1,7.9,2.1,13.8,8.6,17.3Z" />
    <path d="M511,512h-167.9c21-17.9,36.8-41,46.7-67.8l66.2,30.8c20.5,9.6,38.1,22.9,55,37Z" />
    <path d="M168.9,512H.8c17.2-14.3,35-27.6,55.9-37.3l65.5-30.4c9.9,26.8,25.7,49.8,46.7,67.7Z" />
    <path d="M271.3,28.3c-10-1-19.8-1-29.9,0l-.5-11.2c0-8.1,3.9-14.2,11.1-17h8c7.2,2.8,11.2,8.9,11.1,17l.2,11.3Z" />
    <path d="M424.6,198.7c.2,7.6-5.8,15.4-14.8,15.4H102.2c-9,0-15-7.8-14.8-15.4.2-8.3,7-14.6,15.6-14.6h12s.1-19.2.1-19.2c1.1-45.1,23.4-86.5,61.4-112.7v62.8c.2,8.6,6.8,15.1,15,15.3,7.5.1,15.1-6,15.1-14.5V42.2s-.8-5.6-.8-5.6c11.6-4,23.2-7.2,35.6-8.4l-.3,106.6c0,8,7.7,13.7,14.5,13.9,7.1.2,15.3-5.5,15.3-13.9l.4-106.6c12.1,1.2,23.5,4.4,34.9,8.3l-.8,5.6v73.5c0,8.5,7.6,14.6,15.2,14.5,7.4,0,14.7-6,14.7-14.3l.2-63.9c36.8,25.5,58.9,65.1,61.2,108.7l.3,23.2h12c8.6,0,15.3,6.3,15.5,14.6Z" />
    <path d="M378,244.2v55.4c-.2,67.3-55.8,120.4-121.5,120.7-66.2.2-122.3-53-122.4-120.4v-55.7c0,0,243.9,0,243.9,0Z" />
    <path d="M205.5,36.8c-10.3,4.3-18.2,8.5-28.3,14.6l-.7-8.4c.3-7.6,4.8-13.5,12-15.2,6.7-1.6,14.3,2.2,17,9Z" />
    <path d="M335.5,42l-.6,9.4c-9.3-5.6-17.9-10.2-28.4-14.7,2.5-6.4,9.7-10.2,16.1-9.1,7.2,1.2,12,6.8,12.8,14.3Z" />
  </svg>
);

export default SidebarContractorsIcon;
